var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("RoutingPlanTabHeader", {
        attrs: { "is-refreshing": _vm.vm.isRefreshingTargetGroups },
        on: {
          refresh: _vm.vm.refreshTargetGroups,
          "create-new": _vm.vm.openNewTargetGroupModal
        },
        model: {
          value: _vm.filters.name.value,
          callback: function($$v) {
            _vm.$set(_vm.filters.name, "value", $$v)
          },
          expression: "filters.name.value"
        }
      }),
      _vm._v(" "),
      _vm.vm.targetGroups.length
        ? _c(
            "div",
            { staticClass: "grid_table_holder p-10" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty table-condensed",
                  attrs: {
                    data: _vm.vm.targetGroups,
                    "current-page": _vm.currentPage,
                    "page-size": 10,
                    filters: _vm.filters,
                    cellpadding: "0",
                    cellspacing: "0"
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            _vm._l(displayData, function(group) {
                              return _c(
                                "tr",
                                { key: group.id, staticClass: "border_bottom" },
                                [
                                  _c(
                                    "td",
                                    { attrs: { align: "left" } },
                                    [
                                      _c("LinkedName", {
                                        attrs: {
                                          href: _vm.getHref(
                                            "dashboard.targetgroup.edit",
                                            {
                                              targetGroupId: group.id,
                                              name: group.name
                                            }
                                          ),
                                          title: group.name
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", { attrs: { align: "center" } }, [
                                    _c("i", {
                                      class: group.isSimalDial
                                        ? "true typcn typcn-tick"
                                        : "false typcn typcn-times"
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { align: "center" } }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(group.targets.length || 0) +
                                        "\n          "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { align: "center" } }, [
                                    !group.enabled
                                      ? _c("span", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.right.hover",
                                              value: _vm.$t(
                                                "TARGETS_STATUS_DISABLED_GROUP"
                                              ),
                                              expression:
                                                "$t('TARGETS_STATUS_DISABLED_GROUP')",
                                              modifiers: {
                                                right: true,
                                                hover: true
                                              }
                                            }
                                          ],
                                          staticClass: "red_status"
                                        })
                                      : _c("span", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.right.hover",
                                              value: _vm.$t(
                                                "TARGETS_STATUS_OPEN"
                                              ),
                                              expression:
                                                "$t('TARGETS_STATUS_OPEN')",
                                              modifiers: {
                                                right: true,
                                                hover: true
                                              }
                                            }
                                          ],
                                          staticClass: "green_status"
                                        })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { align: "left" } }, [
                                    _c("a", {
                                      staticClass:
                                        "btn btn-list-function typcn typcn-arrow-right-thick",
                                      on: {
                                        click: function($event) {
                                          return _vm.vm.openNewTargetGroupRouteModal(
                                            group
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3793777880
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_GROUPS_NAME",
                              expression: "'CAMPAIGN_STEP_ROUTING_GROUPS_NAME'"
                            }
                          ],
                          staticClass: "column-sortable width-30-percent",
                          attrs: {
                            "sort-key": "name",
                            align: "left",
                            "default-sort": "asc"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_GROUPS_SIMULDIAL",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_GROUPS_SIMULDIAL'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "isSimalDial", align: "center" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_GROUPS_TARGETS",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_GROUPS_TARGETS'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "targets", align: "center" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_GROUPS_STATUS",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_GROUPS_STATUS'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "enabled", align: "center" }
                        }),
                        _vm._v(" "),
                        _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_GROUPS_ADD",
                              expression: "'CAMPAIGN_STEP_ROUTING_GROUPS_ADD'"
                            }
                          ],
                          attrs: { align: "center" }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-0" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 5
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.isLoading
        ? _c("LoadingStatusDisplay", { attrs: { loading: true } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("CAMPAIGN_STEP_ROUTING_LOADING_TARGET_GROUPS")) +
                "\n  "
            )
          ])
        : !_vm.vm.targetGroups.length
        ? _c("div", { staticClass: "col-xs-12" }, [
            _vm._v("\n    " + _vm._s(_vm.noTargetAvailableMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.modal != null
        ? [
            _vm.vm.modal.type === "new-target-group"
              ? _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.vm.closeModal()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      TODO: New Target Group Modal (click to close)\n      "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n      templateUrl: 'scripts/shared/components/select-target/new-target-group.modal.html'\n    "
                    )
                  ]
                )
              : _vm.vm.modal.type === "new-target-group-route"
              ? _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.vm.closeModal()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      TODO: New Target Route  Modal (click to close)\n      "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n      templateUrl: 'scripts/shared/components/select-target/new-target-group-route.modal.html'\n      "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n      " + _vm._s(_vm.vm.modal.target.name) + "\n    "
                    )
                  ]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }